(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/betslip/all-orders.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/betslip/all-orders.js');
"use strict";


const RadioGroup = svs.ui.form.RadioGroup;
const RadioButton = svs.ui.form.RadioButton;
const AllOrders = props => {
  const isAnyOrder = props.isAnyOrder;
  const setAnyOrder = props.setAnyOrder;
  return React.createElement("div", {
    className: "betslip-sequence"
  }, React.createElement("div", {
    className: "picker-header"
  }, "Alla ordningsf\xF6ljder"), React.createElement("div", {
    className: "all-orders-picker form-toggle-racing"
  }, React.createElement(RadioGroup, {
    id: "betslip-sequence",
    multipleLines: false,
    size: "200",
    thin: true,
    transparent: false
  }, React.createElement(RadioButton, {
    branding: "racing",
    checked: !isAnyOrder,
    key: "betslip-use-sequence-no",
    minWidth: "150px",
    name: "betslip-use-sequence-button",
    onChange: () => setAnyOrder(false),
    value: "0"
  }, "Nej"), React.createElement(RadioButton, {
    branding: "racing",
    checked: isAnyOrder,
    key: "betslip-use-sequence-yes",
    minWidth: "150px",
    name: "betslip-use-sequence-button",
    onChange: () => setAnyOrder(true),
    value: "1"
  }, "Ja"))));
};
svs.racing_game.components.play.AllOrders = AllOrders;

 })(window);